import ClippedScroller from './util/ClippedScroller';
import ScrollJoiner from './util/ScrollJoiner';
var HeaderBodyLayout = /** @class */ (function () {
    /*
    verticalScroll = 'auto' | 'clipped-scroll'
    */
    function HeaderBodyLayout(headerContainerEl, bodyContainerEl, verticalScroll) {
        this.headerScroller = new ClippedScroller('clipped-scroll', 'hidden', headerContainerEl);
        this.bodyScroller = new ClippedScroller('auto', verticalScroll, bodyContainerEl);
        this.scrollJoiner = new ScrollJoiner('horizontal', [
            this.headerScroller,
            this.bodyScroller
        ]);
    }
    HeaderBodyLayout.prototype.destroy = function () {
        this.headerScroller.destroy();
        this.bodyScroller.destroy();
    };
    HeaderBodyLayout.prototype.setHeight = function (totalHeight, isAuto) {
        var bodyHeight;
        if (isAuto) {
            bodyHeight = 'auto';
        }
        else {
            bodyHeight = totalHeight - this.queryHeadHeight();
        }
        this.bodyScroller.setHeight(bodyHeight);
        this.headerScroller.updateSize(); // adjusts gutters and classNames
        this.bodyScroller.updateSize(); // adjusts gutters and classNames
        this.scrollJoiner.update();
    };
    HeaderBodyLayout.prototype.queryHeadHeight = function () {
        return this.headerScroller.enhancedScroll.canvas.contentEl.getBoundingClientRect().height;
    };
    return HeaderBodyLayout;
}());
export default HeaderBodyLayout;
